<template>
  <div class="page-container">
    <PageHeader title="PK记录" show-breadcrumb />

    <SearchPanel>
      <el-input v-model.trim="query.qpName" placeholder="试卷名称" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.zauName" placeholder="用户名" clearable size="small" @keyup.enter.native="handleSearch" />
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
        <!-- 导出：按当前筛选条件导出 PK 记录 Excel -->
        <el-button type="success" icon="el-icon-download" size="small" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="PK记录列表">
      <el-table :data="list" v-loading="loading" size="small" stripe :height="tableHeight">
        <el-table-column type="index" label="序号" width="80" align="center" />
        <el-table-column prop="qpName" label="试卷名称" min-width="180" align="center" show-overflow-tooltip />
        <el-table-column label="状态" min-width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="statusTagType(row.qpStatus)">{{ statusText(row.qpStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="qpNums" label="题数" min-width="80" align="center" />
        <el-table-column prop="createtime" label="创建时间" min-width="150" align="center" />
        <!-- 用户1 -->
        <el-table-column label="用户1" min-width="160" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.puGridOne || '-' }}</div>
            <div class="pk-score">{{ row.qprShowScoreOne != null ? row.qprShowScoreOne + ' 分' : '-' }}</div>
          </template>
        </el-table-column>
        <!-- 用户2：机器人加入时昵称为随机名，需加 AI 标识区分人机对战 -->
        <el-table-column label="用户2" min-width="160" align="center">
          <template slot-scope="{ row }">
            <div class="pk-user-cell">
              <span class="pk-user-cell__name">{{ row.puGridTwo || '-' }}</span>
              <span v-if="isRobotPk(row)" class="pk-robot-icon" title="AI机器人对战">🤖</span>
            </div>
            <div class="pk-score">{{ row.qprShowScoreTwo != null ? row.qprShowScoreTwo + ' 分' : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" style="color:#409eff" @click="handleDetail(row)">详情</el-button>
            <el-button type="text" size="mini" style="color:#67c23a" @click="handlePoints(row)">积分</el-button>
            <el-button type="text" size="mini" style="color:#e6a23c" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>

    <!-- PK 试卷详情：对战双方总览 + 答题对比 -->
    <el-dialog title="PK记录详情" :visible.sync="detailVisible" width="860px" v-dialog-drag-resize>
      <div v-loading="detailLoading" class="pk-detail">
        <template v-if="detail">
          <div class="pk-detail__title">{{ detail.qpName || '-' }}</div>
          <div class="pk-detail__meta">
            <span>状态：<el-tag size="mini" :type="statusTagType(detail.qpStatus)">{{ statusText(detail.qpStatus) }}</el-tag></span>
            <span>题数：{{ detail.qpNums != null ? detail.qpNums : '-' }}</span>
            <span>创建时间：{{ detail.createtime || '-' }}</span>
            <span v-if="isRobotPk(detail)">类型：<el-tag size="mini" type="warning" effect="plain">人机对战</el-tag></span>
          </div>
          <div class="pk-vs">
            <!-- 用户1 -->
            <div class="pk-player" :class="{ 'is-win': winner === 1 }">
              <el-avatar :size="56" :src="detail.puGridHeaderOne">{{ (detail.puGridOne || '用户1').slice(0, 1) }}</el-avatar>
              <div class="pk-player__name">{{ detail.puGridOne || '用户1' }}</div>
              <div class="pk-player__score">{{ detail.qprShowScoreOne != null ? detail.qprShowScoreOne : 0 }} 分</div>
              <div class="pk-player__time">用时：{{ detail.qprTotalTimeOne != null ? detail.qprTotalTimeOne + 's' : '-' }}</div>
              <div class="pk-player__status">状态：<el-tag size="mini" :type="statusTagType(detail.qpStatusOne)">{{ statusText(detail.qpStatusOne) }}</el-tag></div>
            </div>
            <div class="pk-vs__center">VS</div>
            <!-- 用户2：人机对战时昵称为随机机器人名，加 AI 标识 -->
            <div class="pk-player" :class="{ 'is-win': winner === 2 }">
              <el-avatar :size="56" :src="detail.puGridHeaderTwo">{{ (detail.puGridTwo || '用户2').slice(0, 1) }}</el-avatar>
              <div class="pk-player__name">
                {{ detail.puGridTwo || '用户2' }}
                <span v-if="isRobotPk(detail)" class="pk-robot-icon" title="AI机器人对战">🤖</span>
              </div>
              <div class="pk-player__score">{{ detail.qprShowScoreTwo != null ? detail.qprShowScoreTwo : 0 }} 分</div>
              <div class="pk-player__time">用时：{{ detail.qprTotalTimeTwo != null ? detail.qprTotalTimeTwo + 's' : '-' }}</div>
              <div class="pk-player__status">状态：<el-tag size="mini" :type="statusTagType(detail.qpStatusTwo)">{{ statusText(detail.qpStatusTwo) }}</el-tag></div>
            </div>
          </div>

          <!-- 答题对比：逐题展示双方作答描述、得分与对错 -->
          <div class="pk-compare">
            <div class="pk-compare__title">📝 答题对比</div>
            <div v-if="!compareList.length" class="pk-compare__empty">暂无答题明细</div>
            <div v-for="(c, idx) in compareList" :key="c.qtId || idx" class="pk-topic">
              <div class="pk-topic__head">
                <span class="pk-topic__no">第 {{ idx + 1 }} 题</span>
                <el-tag size="mini">{{ c.qttName || '-' }}</el-tag>
              </div>
              <div class="pk-topic__stem">{{ c.qtName || '-' }}</div>
              <!-- 用户1作答行 -->
              <div class="pk-ans pk-ans--one" :class="ansCls(c.one)">
                <span class="pk-ans__name">{{ playerOneName }}</span>
                <span class="pk-ans__text">{{ ansText(c.one) }}</span>
                <span class="pk-ans__score">{{ ansScore(c.one) }}</span>
                <span class="pk-ans__mark">{{ ansMark(c.one) }}</span>
              </div>
              <!-- 用户2作答行 -->
              <div class="pk-ans pk-ans--two" :class="ansCls(c.two)">
                <span class="pk-ans__name">{{ playerTwoName }}</span>
                <span class="pk-ans__text">{{ ansText(c.two) }}</span>
                <span class="pk-ans__score">{{ ansScore(c.two) }}</span>
                <span class="pk-ans__mark">{{ ansMark(c.two) }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div slot="footer">
        <el-button size="small" @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 本场积分记录：按试卷id关联查询该场次双方积分变动明细 -->
    <el-dialog :title="'积分记录' + (pointsPaper ? ' - ' + pointsPaper : '')" :visible.sync="pointsVisible" width="640px" v-dialog-drag-resize>
      <el-table :data="pointsList" v-loading="pointsLoading" size="small" stripe>
        <el-table-column label="用户" min-width="130" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.zauName || ('用户' + row.zauId) }}</template>
        </el-table-column>
        <el-table-column label="积分变动" min-width="90" align="center">
          <template slot-scope="{ row }">
            <span :class="pointsCls(row.puprPoints)">{{ pointsText(row.puprPoints) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="puprPointsDes" label="积分描述" min-width="200" align="center" show-overflow-tooltip />
        <el-table-column label="时间" min-width="150" align="center">
          <template slot-scope="{ row }">{{ formatTime(row.createtime) }}</template>
        </el-table-column>
      </el-table>
      <div v-if="!pointsLoading && !pointsList.length" class="points-empty">本场暂无积分记录</div>
      <div slot="footer">
        <el-button size="small" @click="pointsVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getPkqPaperList, getPkqPaperById, deletePkqPaper, exportPkqPaperList, getPkqUserPointsRecordList } from '@/api/api'

// PK 试卷状态字典：1 已创建 / 2 答题中 / 3 已答题 / 4 已过期
const STATUS_MAP = { 1: { label: '已创建', type: 'info' }, 2: { label: '答题中', type: 'warning' }, 3: { label: '已答题', type: 'success' }, 4: { label: '已过期', type: 'info' } }

export default {
  name: 'PkqPaper',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      exportLoading: false,
      tableHeight: 400,
      list: [],
      query: { qpName: '', zauName: '' },
      page: { currentPage: 1, pageSize: 10, total: 0 },
      detailVisible: false,
      detailLoading: false,
      detail: null,
      // 本场积分记录弹窗状态
      pointsVisible: false,
      pointsLoading: false,
      pointsList: [],
      pointsPaper: ''
    }
  },
  computed: {
    // 根据双方得分判定胜负（得分高者胜，相等为平）
    winner () {
      if (!this.detail) return 0
      const a = Number(this.detail.qprShowScoreOne)
      const b = Number(this.detail.qprShowScoreTwo)
      if (a > b) return 1
      if (b > a) return 2
      return 0
    },
    // 用户1昵称（缺省显示"用户1"）
    playerOneName () {
      return (this.detail && this.detail.puGridOne) || '用户1'
    },
    // 用户2昵称（缺省显示"用户2"）
    playerTwoName () {
      return (this.detail && this.detail.puGridTwo) || '用户2'
    },
    // 双方逐题作答对齐：以用户1题目为基准，用 qtId 匹配用户2同卷题目
    // （后端 qptOrder 均为 1 未按题序赋值，故用 qtId 对齐，题序取遍历顺序）
    compareList () {
      if (!this.detail) return []
      const listOne = ((this.detail.pkqPaperRecordOne || {}).pkqPaperTopicList) || []
      const listTwo = ((this.detail.pkqPaperRecordTwo || {}).pkqPaperTopicList) || []
      const twoMap = {}
      listTwo.forEach(t => { twoMap[t.qtId] = t })
      return listOne.map(t => ({ qtId: t.qtId, qtName: t.qtName, qttName: t.qttName, one: t, two: twoMap[t.qtId] || null }))
    }
  },
  created () { this.fetchList() },
  mounted () {
    this.$nextTick(this.calcTableHeight)
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy () { window.removeEventListener('resize', this.calcTableHeight) },
  methods: {
    statusText (s) { return (STATUS_MAP[s] && STATUS_MAP[s].label) || '-' },
    statusTagType (s) { return (STATUS_MAP[s] && STATUS_MAP[s].type) || 'info' },
    // 是否人机对战：后端约定机器人作为加入者 puIdTwo=0（null 表示尚无人加入，不算机器人）
    isRobotPk (row) { return row && Number(row.puIdTwo) === 0 },
    // 作答文字：无记录或无作答描述显示"未作答"
    ansText (t) { return (t && t.qptAnswerDes) ? t.qptAnswerDes : '未作答' },
    // 作答是否正确：qtScoreRight === 2 为正确
    isRight (t) { return !!(t && Number(t.qtScoreRight) === 2) },
    // 作答行样式：正确绿色、错误红色、未作答灰色
    ansCls (t) {
      if (!t || !t.qptAnswerDes) return 'is-none'
      return this.isRight(t) ? 'is-right' : 'is-wrong'
    },
    // 单题得分
    ansScore (t) { return (t && t.qtScoreUser != null ? t.qtScoreUser : 0) + ' 分' },
    // 对错标识（未作答无标识）
    ansMark (t) {
      if (!t || !t.qptAnswerDes) return ''
      return this.isRight(t) ? '✓' : '✗'
    },
    calcTableHeight () {
      const el = this.$el.querySelector('.el-table')
      if (!el) return
      this.tableHeight = window.innerHeight - el.getBoundingClientRect().top - 80
    },
    async fetchList () {
      this.loading = true
      try {
        // 只传有值的筛选条件，避免空串传给后端
        const params = { currentPage: this.page.currentPage, pageSize: this.page.pageSize }
        if (this.query.qpName) params.qpName = this.query.qpName
        if (this.query.zauName) params.zauName = this.query.zauName
        const res = await getPkqPaperList(params)
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { qpName: '', zauName: '' }; this.handleSearch() },
    // 导出 PK 记录 Excel：筛选条件与当前列表保持一致（试卷名称/用户名模糊）
    async handleExport () {
      this.exportLoading = true
      try {
        await exportPkqPaperList({ qpName: this.query.qpName || undefined, zauName: this.query.zauName || undefined })
        this.$message.success('导出成功')
      } catch (e) { /* 失败提示已在 exportFile 内统一处理 */ } finally { this.exportLoading = false }
    },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    async handleDetail (row) {
      this.detailVisible = true
      this.detailLoading = true
      this.detail = null
      try {
        const res = await getPkqPaperById({ qpId: row.qpId })
        this.detail = res.data || null
      } catch (e) { this.detail = null } finally {
        this.detailLoading = false
      }
    },
    async handleDelete (row) {
      try { await this.$confirm('确定删除该 PK 试卷？', '提示', { type: 'warning' }) } catch { return }
      try {
        await deletePkqPaper({ qpId: row.qpId })
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {}
    },
    // 查看本场积分记录：按试卷id查该场次双方积分变动（一场记录数有限，一次取完不分页）
    async handlePoints (row) {
      this.pointsVisible = true
      this.pointsLoading = true
      this.pointsList = []
      this.pointsPaper = row.qpName || ('#' + row.qpId)
      try {
        const res = await getPkqUserPointsRecordList({ qpId: row.qpId, currentPage: 1, pageSize: 50 })
        this.pointsList = res.data || []
      } catch (e) { this.pointsList = [] } finally { this.pointsLoading = false }
    },
    // 积分实体未加 @JsonFormat，可能返回 ISO 格式(带T)，统一转成 yyyy-MM-dd HH:mm:ss 展示
    formatTime (t) {
      if (!t) return '-'
      return String(t).replace('T', ' ').replace(/\.\d+$/, '')
    },
    // 积分变动样式：加分绿色、扣分红色、0 灰色
    pointsCls (v) {
      const n = Number(v) || 0
      if (n > 0) return 'is-plus'
      if (n < 0) return 'is-minus'
      return 'is-zero'
    },
    pointsText (v) {
      const n = Number(v) || 0
      return n > 0 ? '+' + n : String(n)
    }
  }
}
</script>

<style lang="scss" scoped>
.pk-score { font-size: 12px; color: #67c23a; margin-top: 2px; }
/* 用户2 单元格：昵称 + AI 小图标同行排列 */
.pk-user-cell { display: flex; align-items: center; justify-content: center; gap: 4px; }
.pk-user-cell__name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pk-robot-icon { flex: 0 0 auto; font-size: 14px; line-height: 1; cursor: help; }
.pk-detail { min-height: 200px; max-height: 64vh; overflow-y: auto; padding-right: 4px; }
.pk-detail__title { font-size: 18px; font-weight: 600; color: #1f2937; text-align: center; }
.pk-detail__meta { display: flex; justify-content: center; gap: 24px; margin: 12px 0 24px; font-size: 13px; color: #64748b; }
.pk-vs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
}
.pk-player {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 28px;
  border-radius: 14px;
  border: 2px solid #e5e7eb;
  background: #fafbfc;
  min-width: 200px;
  &.is-win { border-color: #f59e0b; background: #fffbeb; box-shadow: 0 4px 14px rgba(245, 158, 11, 0.18); }
}
.pk-player__name { font-size: 15px; font-weight: 600; color: #1f2937; }
.pk-player__score { font-size: 20px; font-weight: 700; color: var(--fn-primary); }
.pk-player__time { font-size: 12px; color: #94a3b8; }
.pk-player__status { font-size: 12px; color: #64748b; }
.pk-vs__center { font-size: 22px; font-weight: 800; color: #ef4444; letter-spacing: 2px; }

/* ===== 答题对比区 ===== */
.pk-compare { margin-top: 22px; }
.pk-compare__title { font-size: 15px; font-weight: 600; color: #1e293b; margin-bottom: 12px; }
.pk-compare__empty { text-align: center; color: #909399; padding: 28px 0; font-size: 13px; }
.pk-topic {
  padding: 14px 16px;
  margin-bottom: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fafbfc;
}
.pk-topic__head { display: flex; align-items: center; gap: 10px; margin-bottom: 8px; font-size: 13px; color: #475569; }
.pk-topic__no { font-weight: 600; color: #1e293b; }
.pk-topic__stem { font-size: 14px; color: #1f2937; line-height: 1.7; margin-bottom: 10px; }
.pk-ans {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  margin-top: 8px;
  &.is-right { background: #ecfdf5; border-color: #6ee7b7; }
  &.is-wrong { background: #fef2f2; border-color: #fca5a5; }
  &.is-none { background: #f8fafc; border-color: #e2e8f0; color: #94a3b8; }
}
.pk-ans__name { flex: 0 0 auto; font-weight: 600; color: #475569; min-width: 56px; }
.pk-ans__text { flex: 1; color: #1f2937; word-break: break-all; }
.pk-ans--two .pk-ans__name { color: #6d28d9; }
.pk-ans__score { flex: 0 0 auto; color: #64748b; }
.pk-ans__mark { flex: 0 0 auto; font-weight: 700; font-size: 15px; }
.pk-ans.is-right .pk-ans__mark { color: #16a34a; }
.pk-ans.is-wrong .pk-ans__mark { color: #dc2626; }
/* 积分记录弹窗 */
.points-empty { text-align: center; color: #909399; padding: 20px 0; font-size: 13px; }
.is-plus { color: #16a34a; font-weight: 700; }
.is-minus { color: #dc2626; font-weight: 700; }
.is-zero { color: #94a3b8; }
</style>
